import React, { useEffect, useState } from "react";
import "./MyReports.css";
import MyEarningsDetails from "./MyEarningsDetails";

import axios from "./../../axios";

export default function MyReports({ onReportsSubPageChange }) {
  const [reportData, setReportData] = useState(null);
  const [showEarningsDetails, setShowEarningsDetails] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const formatINR = (value) => {
    const amount = Number(value) || 0;
    return `₹${amount.toLocaleString("en-IN")}`;
  };

  const fetchReports = (startDate = "", endDate = "") => {
    setLoadingData(true);
    let url = "/v1/tutor/reports/count";
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    return axios
      .get(url)
      .then((res) => {
        if (res.data.is_success) {
          setReportData(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch reports", err);
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    if (onReportsSubPageChange) {
      onReportsSubPageChange(showEarningsDetails ? "earnings" : null);
    }
  }, [showEarningsDetails, onReportsSubPageChange]);

  if (!reportData) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <div className="loading">
          <img src="./book-loader.gif" alt=" Loading . . .  " />
        </div>
      </div>
    );
  }

  const { recommended, demo, confirmed } = reportData;
  const earnings = reportData?.earnings || {};
  const totalEarnings = earnings.total ?? earnings.total_earnings ?? 0;
  const lastMonthEarnings = earnings.last_month ?? earnings.lastMonth ?? 0;

  if (showEarningsDetails) {
    return (
      <MyEarningsDetails
        totalEarnings={totalEarnings}
        lastMonthEarnings={lastMonthEarnings}
        earnings={earnings}
        onBack={() => setShowEarningsDetails(false)}
        onApplyFilter={fetchReports}
        loadingData={loadingData}
      />
    );
  }

  return (
    <div className="myreports-container">
      <div className="report-heading">Class Insights</div>
      <div className="myreports-cards-row">
        <div className="myreports-card reports-blue-bg">
          <div className="myreports-title">Recommended Till Date</div>
          <div className="myreports-number blue-text">{recommended.total}</div>
          <div className="myreports-subtext">
            {recommended.applied} of {recommended.total} classes applied
          </div>
          {/* <div className="myreports-link">View Details →</div> */}
        </div>
        <div className="myreports-card reports-blue-bg">
          <div className="myreports-title">Classes Assigned</div>
          <div className="myreports-number blue-text">{demo.total}</div>
          <div className="myreports-subtext">{demo.confirmed} Demo’s Scheduled</div>
          {/* <div className="myreports-link">View Details →</div> */}
        </div>
        <div className="myreports-card reports-blue-bg">
          <div className="myreports-title">Tuition Confirmed</div>
          <div className="myreports-number blue-text">{confirmed.total}</div>
          <div className="myreports-subtext">{"  "}</div>
          {/* <div className="myreports-link">View Details →</div> */}
        </div>
      </div>

      <div className="report-heading report-subsection-heading">Earnings Overview</div>
      <div className="myreports-cards-row myreports-single-card-row">
        <div className="myreports-card green-bg">
          <div className="myreports-title">My total Earnings</div>
          <div className="myreports-number green-text">{formatINR(totalEarnings)}</div>
          <div className="myreports-subtext">Last month earnings: {formatINR(lastMonthEarnings)}</div>
          <button type="button" className="myreports-link-btn" onClick={() => setShowEarningsDetails(true)}>
            View Details →
          </button>
        </div>
      </div>
    </div>
  );
}
